import { render, staticRenderFns } from "./PH2V.vue?vue&type=template&id=f7bd060c&scoped=true"
import script from "./PH2V.vue?vue&type=script&lang=js"
export * from "./PH2V.vue?vue&type=script&lang=js"
import style0 from "./PH2V.vue?vue&type=style&index=0&id=f7bd060c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7bd060c",
  null
  
)

export default component.exports